import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import {Controller, useForm} from "react-hook-form";
import classes from './form.module.scss';
import {useNavigate} from 'react-router-dom';
import errorMessage from "../../../../const/Tost";
import {createClinic} from "./ClinicData";
import {DirectionService} from "../../../../api/directionService";
import CreatableSelect from "react-select/creatable";
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const AddClinic = () => {
    const {
        register,
        handleSubmit,
        control,
        formState: {errors},
    } = useForm();
    const values = createClinic;
    const navigate = useNavigate();

    const [fileName, setFileName] = useState("Оберіть файл");
    const role = useSelector(state=> state?.login?.userInfo?.permissions?.hospitals_manage)

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file){
            setFileName(file.name);  // Set the file name to display in the label
            const reader = new FileReader();

            reader.readAsDataURL(file);  // Read the file as a data URL (base64)
        }
    };

    const onSubmit = async(data) => {
        try{
            await DirectionService.createClinic({...data, registrationType: "COMPLETED"}).then(res => {
                if (res) navigate('/ClinicList')
            });
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }

    useEffect(()=>{
        if(!role){
            navigate('/Home')
            toast.error('В доступі відмовлено!')
        }
    },[])

    return (
        <>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                <div className={classes.form__wrapper}>
                    <div className={classNames(classes.form__title)}>
                        Реєстрація нової клініки
                    </div>
                </div>
                {values.fields.map((el, index) => (
                    <div className={classes[values.class]} key={index}>
                        <div
                            className={classNames(
                                el.name == 'cassetsAfter'
                                    ? classes.form__input__cassets
                                    : classes.form__label__container,
                                {[classes.register__container]: values.formType == 'singIn'}
                            )}
                        >

                            {el.options ? (
                                <>
                                    <div style={{width: '30%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}>
                                        <label>{el.legend}</label></div>
                                    <div style={{width:'350px'}}>
                                        <Controller
                                            control={control}
                                            name={el.name}
                                            rules={{}}
                                            render={({field: {onChange, value}}) => (
                                                <CreatableSelect
                                                    className={classNames(classes.react__select)}
                                                    isMulti
                                                    options={el.props}
                                                    value={
                                                        value?.map(val => {
                                                            const found = el.props.find(option => option.value === val || option.label === val);
                                                            return (
                                                                found || {
                                                                    label: val,
                                                                    value: val,
                                                                }
                                                            );
                                                        }) || []
                                                    }
                                                    onChange={(selectedOptions) => {
                                                        const newValues = selectedOptions.map(option => option.value);
                                                        onChange(newValues);
                                                    }}
                                                    placeholder="Введіть значення і натисніть Enter"
                                                    getOptionLabel={(option) => option.label}
                                                    getOptionValue={(option) => option.value}
                                                    isClearable={false}
                                                    formatCreateLabel={(inputValue) => `${inputValue}`}
                                                />
                                            )}
                                        />
                                    </div>
                                </>
                            ) : (
                                <>
                                    {el.props.map((props, i) => (
                                        <div
                                            className={classNames(
                                                classes.form__label__container__box,
                                                {[classes.register__container]: values.formType == 'singIn'}
                                            )}
                                            key={'a' + i}
                                        >
                                            <div><label>{props.label}</label></div>
                                            {el.type === 'file' ? (
                                                <div className={classes.form__fileInput__wrapper}>
                                                    <label className={classes.form__fileInput__label}>
                                                        {fileName}
                                                        <input
                                                            className={classNames(classes.form__fileInput, {[classes.errorInput]: errors[el.name]})}
                                                            type='file'
                                                            placeholder={props.placeholder}
                                                            onChange={(e) => handleFileChange(e)}
                                                        />
                                                    </label>
                                                </div>
                                            ) : (
                                                <div>
                                                    <div className={el.name == 'cassetsAfter' ? classes.form__input__cassets : {}}>
                                                        <input
                                                            className={classNames(classes.form__input, {[classes.errorInput]: errors[el.name]})}
                                                            type={props.type}
                                                            min={props.min}
                                                            max={props.max}
                                                            disabled={props.show}
                                                            placeholder={props.placeholder}
                                                            pattern={props.pattern}
                                                            value={el.type == 'radio' ? props.label : props.value}
                                                            {...register(
                                                                el.name == 'age' || el.name == 'cassetsAfter'
                                                                    ? props.register
                                                                    : el.name,
                                                                {required: el.required}
                                                            )}
                                                        />
                                                    </div>

                                                    {errors[el.name] && (
                                                        <p className={classNames('DefaultForm-input-hint', classes.errorHint)}>
                                                            Це поле є обов'язковим
                                                        </p>
                                                    )}
                                                </div>
                                            )}

                                        </div>
                                    ))}
                                </>
                            )}
                        </div>
                    </div>
                ))}
                <button className={classes.form__button} type="submit">{values.button}</button>
            </form>
        </>
    );
}

export default AddClinic;
